import { render, staticRenderFns } from "./outboundDetails.vue?vue&type=template&id=4f6c5914&scoped=true&"
import script from "./outboundDetails.vue?vue&type=script&lang=js&"
export * from "./outboundDetails.vue?vue&type=script&lang=js&"
import style0 from "./outboundDetails.vue?vue&type=style&index=0&id=4f6c5914&scoped=true&lang=css&"
import style1 from "./outboundDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c5914",
  null
  
)

export default component.exports